import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "dropdown-header" }
const _hoisted_2 = ["title", "href"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "dropdown-header" }
const _hoisted_6 = ["title", "href"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_job_scm_status_badge = _resolveComponent("job-scm-status-badge")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.exportSynchState && _ctx.exportAuthz)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _cache[0] || (_cache[0] = _createElementVNode("li", { class: "divider" }, null, -1)),
          _createElementVNode("li", _hoisted_1, _toDisplayString(_ctx.$t("scm.export.plugin")), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exportActions, (action) => {
            return (_openBlock(), _createElementBlock("li", null, [
              _createElementVNode("a", {
                title: action.description,
                href: _ctx.scmActionHref(action.id, 'export')
              }, _toDisplayString(action.title), 9, _hoisted_2)
            ]))
          }), 256)),
          (_ctx.exportSynchState !== 'CREATE_NEEDED')
            ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
                _createElementVNode("a", {
                  href: _ctx.scmDiffHref('export')
                }, [
                  _createVNode(_component_job_scm_status_badge, {
                    notext: true,
                    icon: "glyphicon-eye-open",
                    "export-status": _ctx.exportSynchState
                  }, null, 8, ["export-status"]),
                  (_ctx.exportSynchState === 'CLEAN')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.$t("scm.action.diff.clean.button.label")), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_ctx.$t("scm.action.diff.button.label")), 1)
                      ], 64))
                ], 8, _hoisted_4)
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.importSynchState && _ctx.importAuthz)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _cache[1] || (_cache[1] = _createElementVNode("li", { class: "divider" }, null, -1)),
          _createElementVNode("li", _hoisted_5, _toDisplayString(_ctx.$t("scm.import.plugin")), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.importActions, (action) => {
            return (_openBlock(), _createElementBlock("li", null, [
              _createElementVNode("a", {
                title: action.description,
                href: _ctx.scmActionHref(action.id, 'import')
              }, _toDisplayString(action.title), 9, _hoisted_6)
            ]))
          }), 256)),
          (_ctx.importSynchState !== 'UNKNOWN')
            ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                _createElementVNode("a", {
                  href: _ctx.scmDiffHref('import')
                }, [
                  _createVNode(_component_job_scm_status_badge, {
                    notext: true,
                    icon: "glyphicon-eye-open",
                    exportStatus: _ctx.importSynchState
                  }, null, 8, ["exportStatus"]),
                  (_ctx.importSynchState === 'CLEAN')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.$t("scm.action.diff.clean.button.label")), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_ctx.$t("scm.action.diff.button.label")), 1)
                      ], 64))
                ], 8, _hoisted_8)
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}